import React from 'react';

export default ({ width = 40, height = 40 }) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 270 270"
  >
    <title>reader</title>
    <path d="M212.91,180.44c1.63,21.82-16.89,43.2-43.74,45.2l-52.84,1.93c-26.85,2-46-14.13-47.63-35.95l-3.29-44.19-12,.89,3.29,44.2c2.12,28.41,27.05,49.51,60.49,47l52.85-3.94c33.44-2.49,58.93-27.63,56.81-56l-3.29-44.19-12,.89Z" />
    <path d="M129.22,44c41.42-3.08,77.62,22.34,80.71,63.76l12-.9c-3.57-48-45.54-82.4-93.56-78.82S44.17,77.53,47.74,125.55l12-.9A75.41,75.41,0,0,1,129.22,44Z" />
    <path d="M180.31,115.67l12-.89c-2.36-31.68-30.06-58.54-61.74-56.18S74.83,85.79,77.19,117.47l12-.89c-1.87-25.09,17.18-41.15,42.27-43A45.66,45.66,0,0,1,180.31,115.67Z" />
    <path d="M116.57,113.24c-1.2,9.77,6.33,15.71,16.1,16.91s18.07-2.8,19.27-12.57a17.82,17.82,0,0,0-35.37-4.34Z" />
  </svg>
);
